import { render, staticRenderFns } from "./checkout-delivery-widget.vue?vue&type=template&id=32e19636&"
import script from "./checkout-delivery-widget.vue?vue&type=script&lang=js&"
export * from "./checkout-delivery-widget.vue?vue&type=script&lang=js&"
import style0 from "./checkout-delivery-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e19636')) {
      api.createRecord('32e19636', component.options)
    } else {
      api.reload('32e19636', component.options)
    }
    module.hot.accept("./checkout-delivery-widget.vue?vue&type=template&id=32e19636&", function () {
      api.rerender('32e19636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-delivery-widget/checkout-delivery-widget.vue"
export default component.exports